module.exports = __webpack_public_path__ + "static/media/buildCapacity.4c93dd7c.svg";